import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { ActionCommentRequestBody, ActionResponseBody, EntityType } from '../models/action.interface';
import { MemberFranchiseItem, MemberProfile, MemberProfileSearch } from '../models/member.interface';
import { PagedResponse } from '../models/paged-response';
import { SearchRequest, searchRequestToUri } from '../models/search-request';
import { PROTECTED_API_URL } from '../tokens/api.tokens';

@Injectable({
  providedIn: 'root',
})
export class MemberProfilesService {
  private http: HttpClient = inject(HttpClient);
  private readonly apiUrl: string;

  constructor(@Inject(PROTECTED_API_URL) apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  searchProfiles(search: SearchRequest<MemberProfileSearch>) {
    const searchString = searchRequestToUri(search);
    return this.http.get<PagedResponse<MemberProfile>>(`${this.apiUrl}/members?${searchString}`);
  }

  getClientProfile(id: string) {
    return this.http.get<MemberProfile>(`${this.apiUrl}/members/${id}`);
  }

  getClientProfileByUserId(userId: string): Observable<MemberProfile> {
    return this.http.get<MemberProfile>(`${this.apiUrl}/members/by-user/${userId}`);
  }

  getClientProfileComments(entityId: string): Observable<PagedResponse<ActionResponseBody>> {
    const requestBody = {
      pageSize: 100,
      sortBy: 'CreatedAt',
      sortDirection: 'desc',
      entityId,
      entityType: EntityType.Member,
    };
    return this.http.post<PagedResponse<ActionResponseBody>>(`${this.apiUrl}/notes/search`, requestBody);
  }

  createClientProfileComment(action: ActionCommentRequestBody): Observable<ActionResponseBody> {
    return this.http.post<ActionResponseBody>(`${this.apiUrl}/notes`, action);
  }

  updateClientProfileComment(actionId: string, actionContent: string): Observable<ActionResponseBody> {
    const requestBody = {
      content: actionContent,
    };
    return this.http.patch<ActionResponseBody>(`${this.apiUrl}/notes/${actionId}`, requestBody);
  }

  deleteClientProfileComment(actionId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/notes/${actionId}/archive`);
  }

  getPackageFranchisesByUserId(userId: string): Observable<MemberFranchiseItem[]> {
    return this.http.get<MemberFranchiseItem[]>(`${this.apiUrl}/members/by-user/${userId}/franchises`);
  }

  getPackageFranchisesByMemberId(memberId: string): Observable<MemberFranchiseItem[]> {
    return this.http.get<MemberFranchiseItem[]>(`${this.apiUrl}/members/${memberId}/franchises`);
  }
}